import { CancelToken } from 'axios';

import { ITASCA_SAVED_SELECTIONS_URL } from '@/constants/urls';
import { resolveV3 } from '@/endpoints/resolveV3';

import { DBFile } from '../../../../../redux/slices/fileUploadModalSlice';
import DataResponse from '../../../../types';

interface IData {
  saved_selection_pk: string | number;
  feature_pk: string | number;
  fileId: string | number;
}

/**
 * Deletes a saved selection feature attachment
 * @param data The saved selection PK and the feature PK and file Id
 */
export async function deleteSavedSelectionFeatureAttachment(
  data: IData,
  cancelToken?: CancelToken
): Promise<DataResponse<DBFile>> {
  return resolveV3(
    {
      cancelToken,
      method: 'DELETE',
      url: `${ITASCA_SAVED_SELECTIONS_URL}${data.saved_selection_pk}/features/${data.feature_pk}/attachments/${data.fileId}/`,
    },
    {
      baseUrl: 'itasca',
    }
  );
}
